import { useEffect } from 'react';
import { showAlertLong } from '../components/general-components/alert-service';

const nowInMs = new Date().getTime();
const downtimeEnd = 1726027200000; // September 10th, 2024 9:00:00 PM PSTs
const oneHour = 3600000;

export default function useDowntimeToast() {
	useEffect(() => {
		if (nowInMs > downtimeEnd) return;

		const localstorageTimeout = localStorage.getItem('downtime-toast-timeout');

		const integerTimeout = parseInt(localstorageTimeout || '0', 10);

		if (
			!integerTimeout
			|| (nowInMs - integerTimeout) > oneHour
		) {
			showAlertLong({
				message: 'Maintenance window',
				description: 'Greenroom may not be accessible September 10th, between 7-9pm PST.',
				type: 'media-device',
				duration: 5000,
			});

			localStorage.setItem('downtime-toast-timeout', nowInMs.toString());
		}
	}, []);
}
